<!-- begin::Scrolltop -->
<div ktScrollTop [options]="scrollTopOptions" id="kt_scrolltop" class="kt-scrolltop">
	<!-- <img src="../../../../../../assets/media/iq-svg/without_circle/icon_set_3/arrow_up.svg" width="17px" height="17px"
		alt=""> -->
	<svg-icon class="white-config-color d-inline" src="assets/media/iq-svg/without_circle/icon_set_3/arrow_up.svg"></svg-icon>
</div>
<!-- end::Scrolltop -->